import { useEffect, useState } from 'react';
import { FrPageBody } from '../../fr-page-layout/fr-page-body';
import { FrEventDetailsTabsHeader } from './fr-event-details-tabs-header';
import {
    DEFAULT_EVENT_DETAILS_TAB,
    EVENT_DETAILS_TAB_CONFIG,
    EVENTS_TAB_CONFIG,
    FR_TAB_COMPONENTS,
} from '../constants';
import { FrEventDetailsTab } from '../types';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';

export default function FrEventDetailsTabs({
    eventId,
    requestedTab,
}: {
    eventId: number;
    requestedTab?: FrEventDetailsTab;
}) {
    const [activeTab, setActiveTab] = useState<FrEventDetailsTab>(DEFAULT_EVENT_DETAILS_TAB);
    const { rollOutFrFooterAndTabRedesignEnabled } = useEnabledFeatures();

    useEffect(() => {
        setActiveTab(requestedTab ?? DEFAULT_EVENT_DETAILS_TAB);
    }, [eventId, requestedTab]);

    const tabConfig = rollOutFrFooterAndTabRedesignEnabled
        ? EVENTS_TAB_CONFIG
        : EVENT_DETAILS_TAB_CONFIG;
    const TabComponent = activeTab ? FR_TAB_COMPONENTS[activeTab] : undefined;

    return (
        <FrPageBody>
            <FrEventDetailsTabsHeader
                activeTab={activeTab}
                tabConfigs={tabConfig}
                eventId={eventId}
            />
            {!!TabComponent && <TabComponent />}
        </FrPageBody>
    );
}
